import Vue from 'vue';
import Vuex from 'vuex';
import { ActionTree } from 'vuex';
import axios from 'axios';
import { httpClient } from '@/core';
import { tUi } from '@/utils/translate';

// Define una interfaz para representar un objeto de entidad
interface Entity {
  id: string;
  // Otras propiedades de la entidad
}

// Define una interfaz para representar el estado del store
interface CrudState<EntityType extends Entity> {
  entities: EntityType[];
}

const validateStatusResponseOk = (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.data; // Todo está bien
    } else {
      const backendTitle = response?.data?.title;
      const error: any = new Error(
        tUi('response_error.update_entity_failed', { status: response.status })
      );
      error.status = response?.status;
      error.backendTitle = backendTitle;
      throw error;
    }
};

const validateStatusResponseError = (error) => {
  const backendTitle = error?.response?.data?.title || error?.title;
  const normalizedError: any = error || {};
  normalizedError.backendTitle = backendTitle;
  throw normalizedError;
};

// Define las acciones para realizar operaciones CRUD
const actions: ActionTree<CrudState<Entity>, any> = {
  async get({ commit }, payload: { apiUrl: string }) {
      return httpClient().instance.get(payload.apiUrl)
        .then(response => validateStatusResponseOk(response))
        .catch(error => validateStatusResponseError(error));
  },

  async post<EntityType extends Entity>(
    { commit },
    payload: { apiUrl: string; entity: EntityType; array:boolean  }
  ) {
      return httpClient().instance.post(
          payload.apiUrl,
          payload.entity,
          {
            responseType: payload.array ? 'arraybuffer': 'json'
          }
        )        
        .then(response => validateStatusResponseOk(response))
        .catch(error => validateStatusResponseError(error));
  },

  async put<EntityType extends Entity>(
    { commit },
    payload: { apiUrl: string; entity: EntityType }
  ) {
      return httpClient().instance.put(
        payload.apiUrl,
        payload.entity
      )
      .then(response => validateStatusResponseOk(response))
      .catch(error => validateStatusResponseError(error));
  },

  async delete<EntityType extends Entity>(
    { commit },
    payload: { apiUrl: string; entity: EntityType }
  ) {
    return httpClient().instance.delete(
        `${payload.apiUrl}/${payload.entity.id}`
      )
      .then(response => validateStatusResponseOk(response))
      .catch(error => validateStatusResponseError(error));
  },
};

//Vue.use(Vuex);

const httpStore = {
  namespaced: true,
  actions,
};

export default httpStore;
